<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-600">
          <div class="modal-header">
            <slot name="header">
              New Vehicle
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-4">
                  <label for="name">Name:</label>
                </div>
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    ref="vehicle_name"
                    name="name"
                    placeholder="name"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label for="description">Description:</label>
                </div>
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    id="description"
                    ref="vehicle_description"
                    name="description"
                    placeholder="description"
                    v-model="description"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label for="registration">Registration:</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="registration"
                    ref="vehicle_registration"
                    name="registration"
                    placeholder="registration"
                    v-model="registration"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label for="service_due">Service Due Date:</label>
                </div>
                <div class="col-4">
                  <input
                    type="date"
                    class="form-control"
                    id="service_due"
                    ref="vehicle_service_due"
                    name="service_due"
                    v-model="service_due"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "NewVehicleModal",
  data: () => ({
    name: "",
    description: "",
    registration: "",
    service_due: null,
  }),
  methods: {
    ...mapActions("vehicles", ["apiCreateVehicle"]),
    _save() {
      if (!this.$refs.vehicle_name.value) {
        alert("please enter a name");
        return;
      } else if (!this.$refs.vehicle_registration.value) {
        alert("please enter a registration");
        return;
      } else if (!this.$refs.vehicle_description.value) {
        alert("please enter a description");
        return;
      }
      var vehicle = {
        id: 0,
        name: this.$refs.vehicle_name.value,
        registration: this.$refs.vehicle_registration.value,
        description: this.$refs.vehicle_description.value,
        service_due: this.$refs.vehicle_service_due.value,
        active: true,
      };
      this.apiCreateVehicle(vehicle);
      this.$emit("close");
    },
    clear() {
      this.name = "";
      this.description = "";
      this.registration = "";
      this.service_due = null;
    },
  },
  components: {},
};
</script>
